/* 🤖 this file was generated by svg-to-ts*/
export const iconLeaderboardCircle = {
  name: 'leaderboardCircle',
  data: `<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g opacity="0.2">
  <circle cx="14" cy="14" r="14" fill="url(#paint0_linear_314_14303)"/>
  <path d="M13.0764 22.2103V16.4551H9.56826C9.08028 16.4551 8.75057 15.899 8.98796 15.4403L13.8414 5.4728C14.1447 4.81943 15.0811 5.05575 15.0811 5.79254V11.6173H18.431C18.919 11.6173 19.2355 12.1595 19.0245 12.6182L14.3294 22.5162C14.0128 23.1835 13.0764 22.9471 13.0764 22.2103Z" fill="url(#paint1_linear_314_14303)"/>
  </g>
  <path d="M10.3335 20H8.00016C7.6335 20 7.3335 19.7 7.3335 19.3334V12.6667C7.3335 12.3 7.6335 12 8.00016 12H10.3335C10.7002 12 11.0002 12.3 11.0002 12.6667V19.3334C11.0002 19.7 10.7002 20 10.3335 20ZM15.1668 8.00003H12.8335C12.4668 8.00003 12.1668 8.30003 12.1668 8.6667V19.3334C12.1668 19.7 12.4668 20 12.8335 20H15.1668C15.5335 20 15.8335 19.7 15.8335 19.3334V8.6667C15.8335 8.30003 15.5335 8.00003 15.1668 8.00003ZM20.0002 13.3334H17.6668C17.3002 13.3334 17.0002 13.6334 17.0002 14V19.3334C17.0002 19.7 17.3002 20 17.6668 20H20.0002C20.3668 20 20.6668 19.7 20.6668 19.3334V14C20.6668 13.6334 20.3668 13.3334 20.0002 13.3334Z" fill="url(#paint2_linear_314_14303)"/>
  <defs>
  <linearGradient id="paint0_linear_314_14303" x1="-0.484429" y1="20.9619" x2="26.9827" y2="20.9619" gradientUnits="userSpaceOnUse">
  <stop stop-color="#967CFD"/>
  <stop offset="1" stop-color="#3177FF"/>
  </linearGradient>
  <linearGradient id="paint1_linear_314_14303" x1="8.73302" y1="18.4303" x2="18.7211" y2="18.4303" gradientUnits="userSpaceOnUse">
  <stop stop-color="#967CFD"/>
  <stop offset="1" stop-color="#3177FF"/>
  </linearGradient>
  <linearGradient id="paint2_linear_314_14303" x1="14.0002" y1="8.00003" x2="14.0002" y2="20" gradientUnits="userSpaceOnUse">
  <stop stop-color="#967CFD"/>
  <stop offset="1" stop-color="#3177FF"/>
  </linearGradient>
  </defs>
  </svg>
  `,
}
